import { render, staticRenderFns } from "./zhong.vue?vue&type=template&id=413d0b3f&scoped=true&"
import script from "./zhong.vue?vue&type=script&lang=js&"
export * from "./zhong.vue?vue&type=script&lang=js&"
import style0 from "./zhong.vue?vue&type=style&index=0&id=413d0b3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d0b3f",
  null
  
)

export default component.exports